import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-heading text-foreground-950 font-bold">奇优影院</span>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed">
              奇优影院汇集最新电影、最新电视剧，新片上映同步更新快。热门剧集高清免费在线观看，不缓冲流畅播放，追剧首选平台。
            </p>
          </div>
          <div>
            <h4 className="text-foreground-800 font-medium mb-4 text-sm">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/movie" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">最新电影</Link>
              <Link to="/category/tv" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">最新电视剧</Link>
              <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">关于我们</Link>
            </nav>
          </div>
          <div>
            <h4 className="text-foreground-800 font-medium mb-4 text-sm">热门分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="/category/movie" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">科幻电影</a>
              <a href="/category/tv" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">悬疑剧集</a>
              <a href="/category/movie" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">喜剧电影</a>
              <a href="/category/tv" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">古装剧集</a>
            </nav>
          </div>
          <div>
            <h4 className="text-foreground-800 font-medium mb-4 text-sm">联系我们</h4>
            <div className="flex flex-col gap-2 text-foreground-500 text-sm">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@qiyoucinema.com</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-8888</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区光华路9号</span>
              </p>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 奇优影院 qiyoucinema.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-xs transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}